import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@Component({
  selector: 'app-photo-gallery',
  templateUrl: './photo-gallery.component.html',
  styleUrls: ['./photo-gallery.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PhotoGalleryComponent {
  @Input() gallery: any[] = []
  @Input() isMobile: boolean = false

  constructor() {
  }

  @ViewChild('swiper')
  swiperRef: ElementRef | undefined
  active: any

  goToSlide(slide: number) {
    this.active = slide
    this.swiperRef?.nativeElement.swiper.slideTo(slide)
  }

}
